class TasacionesFunnelStep3 extends TasacionesFunnelManager {
    constructor() {
        super({
            stepNumber: 3,
            nextStepUrl: TasacionesConf.step4_url
        });

        this.formValidator = new FormValidator();
        this.priceCalculator = new PriceCalculator();

        // Config
        this.allowedMime = ['application/pdf'];
        this.maxMBPHP = TasacionesConf.upload_max_filesize;
        // Extract max bytes from PHP upload_max_filesize witch is in MB format
        this.maxBytes = parseInt(this.maxMBPHP) * 1024 * 1024;
        this.ajaxUrl = (window.TasacionesConf && TasacionesConf.ajax_url) || '';
        // this.uploadNonce = document.getElementById('tasaciones_upload_nonce')?.value || (window.TasacionesConf && TasacionesConf.upload_nonce) || '';
        this.uploadNonce = (window.TasacionesConf && TasacionesConf.nonce) || '';
        this.pendingUploads = 0;

        this.anadirGarajePriceText = '';
        this.anadirTrasteroPriceText = '';

        this.initStep3Elements();
        this.bindEvents();
        this.updatePrice();
        this.initState();
    }


    initStep3Elements() {
        this.elements = {
            form: document.getElementById('tasaciones-funnel-step-3'),
            submitBtn: document.getElementById('submit-btn-step-3'),
            priceElement: document.getElementById('tasaciones_funnel_price'),

            show_garaje_trastero_container: document.getElementById('show_garaje_trastero_container'),
            show_garaje_trastero: document.getElementById('show_garaje_trastero'),
            garaje_trastero_container: document.getElementById('garaje_trastero_container'),

            // Nota simple
            tieneNotaSimpleRadios: document.querySelectorAll('input[name="tiene_nota_simple"]'),
            notaSimpleContainer: document.getElementById('nota_simple_container'),
            notaSimpleInput: document.getElementById('nota_simple_file'),
            notaSimpleHidden: document.getElementById('nota_simple'),
            notaSimpleText: document.getElementById('nota_simple_text'),
            selectNotaSimpleBtn: document.getElementById('select_nota_simple'),
            removeNotaSimpleBtn: document.getElementById('remove_nota_simple'),

            // CEE
            tieneCEERadios: document.querySelectorAll('input[name="tiene_cee"]'),
            ceeContainer: document.getElementById('cee_container'),
            ceeInput: document.getElementById('cee_file'),
            ceeHidden: document.getElementById('cee'),
            ceeText: document.getElementById('cee_text'),
            selectCeeBtn: document.getElementById('select_cee'),
            removeCeeBtn: document.getElementById('remove_cee'),

            // File 1
            file1Input: document.getElementById('fichero_opcional_1_file'),
            file1Hidden: document.getElementById('fichero_opcional_1'),
            file1Text: document.getElementById('fichero_opcional_1_text'),
            selectFile1Btn: document.getElementById('select_file_1'),
            removeFile1Btn: document.getElementById('remove_file_1'),

            // File 2
            file2Input: document.getElementById('fichero_opcional_2_file'),
            file2Hidden: document.getElementById('fichero_opcional_2'),
            file2Text: document.getElementById('fichero_opcional_2_text'),
            selectFile2Btn: document.getElementById('select_file_2'),
            removeFile2Btn: document.getElementById('remove_file_2'),

            // File 3
            file3Input: document.getElementById('fichero_opcional_3_file'),
            file3Hidden: document.getElementById('fichero_opcional_3'),
            file3Text: document.getElementById('fichero_opcional_3_text'),
            selectFile3Btn: document.getElementById('select_file_3'),
            removeFile3Btn: document.getElementById('remove_file_3'),

            // Garaje
            anadirGarajeCheckbox: document.getElementById('anadir_garaje'),
            anadirGarajeText: document.getElementById('anadir_garaje_text'),
            notaSimpleGarajeContainer: document.getElementById('nota_simple_garaje_container'),
            tieneNotaSimpleGarajeRadios: document.querySelectorAll('input[name="tiene_nota_simple_garaje"]'),
            tieneNotaSimpleGarajeContainer: document.getElementById('tiene_nota_simple_garaje_container'),
            notaSimpleGarajeInput: document.getElementById('nota_simple_garaje_file'),
            notaSimpleGarajeHidden: document.getElementById('nota_simple_garaje'),
            notaSimpleGarajeText: document.getElementById('nota_simple_garaje_text'),
            selectNotaSimpleGarajeBtn: document.getElementById('select_nota_simple_garaje'),
            removeNotaSimpleGarajeBtn: document.getElementById('remove_nota_simple_garaje'),
            // CEE
            tieneCEEGarajeRadios: document.querySelectorAll('input[name="tiene_cee_garaje"]'),
            ceeGarajeContainer: document.getElementById('cee_garaje_container'),
            ceeGarajeInput: document.getElementById('cee_garaje_file'),
            ceeGarajeHidden: document.getElementById('cee_garaje'),
            ceeGarajeText: document.getElementById('cee_garaje_text'),
            selectCeeGarajeBtn: document.getElementById('select_cee_garaje'),
            removeCeeGarajeBtn: document.getElementById('remove_cee_garaje'),

            // Trastero
            anadirTrasteroCheckbox: document.getElementById('anadir_trastero'),
            anadirTrasteroText: document.getElementById('anadir_trastero_text'),
            notaSimpleTrasteroContainer: document.getElementById('nota_simple_trastero_container'),
            tieneNotaSimpleTrasteroRadios: document.querySelectorAll('input[name="tiene_nota_simple_trastero"]'),
            tieneNotaSimpleTrasteroContainer: document.getElementById('tiene_nota_simple_trastero_container'),
            notaSimpleTrasteroInput: document.getElementById('nota_simple_trastero_file'),
            notaSimpleTrasteroHidden: document.getElementById('nota_simple_trastero'),
            notaSimpleTrasteroText: document.getElementById('nota_simple_trastero_text'),
            selectNotaSimpleTrasteroBtn: document.getElementById('select_nota_simple_trastero'),
            removeNotaSimpleTrasteroBtn: document.getElementById('remove_nota_simple_trastero'),
            // CEE
            tieneCEETrasteroRadios: document.querySelectorAll('input[name="tiene_cee_trastero"]'),
            ceeTrasteroContainer: document.getElementById('cee_trastero_container'),
            ceeTrasteroInput: document.getElementById('cee_trastero_file'),
            ceeTrasteroHidden: document.getElementById('cee_trastero'),
            ceeTrasteroText: document.getElementById('cee_trastero_text'),
            selectCeeTrasteroBtn: document.getElementById('select_cee_trastero'),
            removeCeeTrasteroBtn: document.getElementById('remove_cee_trastero'),
        };
        this.filePlaceholder = 'Seleccionar PDF ' + this.maxMBPHP + 'MB max';
    }

    initState() {

        this.anadirGarajePriceText = 0;
        this.anadirTrasteroPriceText = 0;

        if (this.elements.anadirGarajeText) {
            this.anadirGarajePriceText = this.elements.anadirGarajeText?.dataset.price || '';
        }
        if (this.elements.anadirTrasteroText) {
            this.anadirTrasteroPriceText = this.elements.anadirTrasteroText.dataset.price || '';
        }

        if (this.elements.anadirGarajeCheckbox) {
            if (this.elements.anadirGarajeCheckbox.checked) {
                DOMHelpers.setText(this.elements.anadirGarajeText, 'Garaje añadido por ' + this.anadirGarajePriceText);
            } else {
                DOMHelpers.setText(this.elements.anadirGarajeText, 'Añadir garaje a la tasación por ' + this.anadirGarajePriceText);
            }
        }

        if (this.elements.anadirTrasteroCheckbox) {
            if (this.elements.anadirTrasteroCheckbox.checked) {
                DOMHelpers.setText(this.elements.anadirTrasteroText, 'Trastero añadido por ' + this.anadirTrasteroPriceText);
            } else {
                DOMHelpers.setText(this.elements.anadirTrasteroText, 'Añadir trastero a la tasación por ' + this.anadirTrasteroPriceText);
            }
        }

        this.syncLoadedState({
            hiddenId: 'nota_simple',
            labelId: 'nota_simple_text',
            button: this.elements.selectNotaSimpleBtn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="nota_simple"]')
        });
        this.syncLoadedState({
            hiddenId: 'cee',
            labelId: 'cee_text',
            button: this.elements.selectCeeBtn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="cee"]')
        });
        this.syncLoadedState({
            hiddenId: 'fichero_opcional_1',
            labelId: 'fichero_opcional_1_text',
            button: this.elements.selectFile1Btn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="fichero_opcional_1"]')
        });
        this.syncLoadedState({
            hiddenId: 'fichero_opcional_2',
            labelId: 'fichero_opcional_2_text',
            button: this.elements.selectFile2Btn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="fichero_opcional_2"]')
        });
        this.syncLoadedState({
            hiddenId: 'fichero_opcional_3',
            labelId: 'fichero_opcional_3_text',
            button: this.elements.selectFile3Btn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="fichero_opcional_3"]')
        });


        this.syncLoadedState({
            hiddenId: 'nota_simple_garaje',
            labelId: 'nota_simple_garaje_text',
            button: this.elements.selectNotaSimpleGarajeBtn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="nota_simple_garaje"]')
        });
        this.syncLoadedState({
            hiddenId: 'cee_garaje',
            labelId: 'cee_garaje_text',
            button: this.elements.selectCeeBtn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="cee_garaje"]')
        });

        this.syncLoadedState({
            hiddenId: 'nota_simple_trastero',
            labelId: 'nota_simple_trastero_text',
            button: this.elements.selectNotaSimpleTrasteroBtn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="nota_simple_trastero"]')
        });
        this.syncLoadedState({
            hiddenId: 'cee_trastero',
            labelId: 'cee_trastero_text',
            button: this.elements.selectCeeBtn,
            wrapper: document.querySelector('.file-wrapper[data-hidden-id="cee_trastero"]')
        });

        this.refreshFileWrapperStatus();

        this.validateForm();
    }

    syncLoadedState({ hiddenId, labelId, button, wrapper }) {
        const hidden = document.getElementById(hiddenId);
        const label = document.getElementById(labelId);
        const removeBtn = wrapper?.querySelector('.button-remove');
        if (hidden?.value) {
            const fileName = hidden.value.split('/').pop();
            if (label) label.value = fileName;
            this.markUploadOk(button);
            wrapper?.classList.add('has-file');
        } else {
            if (label) label.value = this.filePlaceholder;
            this.resetButton(button);
            wrapper?.classList.remove('has-file');
        }
    }

    bindEvents() {
        if (this.elements.form) {
            this.elements.form.addEventListener('submit', e => this.handleFormSubmit(e));
        }
        this.bindNotaSimpleEvents();
        this.bindCEEEvents();
        this.bindFile1Events();
        this.bindFile2Events();
        this.bindFile3Events();
        this.bindGarajeEvents();
        this.bindCEEGarajeEvents();
        this.bindTrasteroEvents();
        this.bindCEETrasteroEvents();
        this.bindShowGarajeTrasteroEvents();
    }

    bindNotaSimpleEvents() {
        const input = this.elements.notaSimpleInput;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'nota_simple',
                    label: this.elements.notaSimpleText,
                    button: this.elements.selectNotaSimpleBtn,
                    hiddenId: 'nota_simple'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectNotaSimpleBtn?.addEventListener('click', () => input?.click());
        this.elements.removeNotaSimpleBtn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'nota_simple',
                hiddenId: 'nota_simple',
                label: this.elements.notaSimpleText,
                button: this.elements.selectNotaSimpleBtn
            });
            this.validateForm();
        });
        this.elements.tieneNotaSimpleRadios.forEach(r => {
            r.addEventListener('change', () => {
                if (r.value === "si" && r.checked) DOMHelpers.show(this.elements.notaSimpleContainer);
                if (r.value !== "si" && r.checked) {
                    DOMHelpers.hide(this.elements.notaSimpleContainer);
                    this.removeUploadedFile({
                        key: 'nota_simple',
                        hiddenId: 'nota_simple',
                        label: this.elements.notaSimpleText,
                        button: this.elements.selectNotaSimpleBtn,
                        silentIfEmpty: true
                    });
                }
                this.updatePrice();
                this.validateForm();
            });
        });
    }

    bindCEEEvents() {
        const input = this.elements.ceeInput;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'cee',
                    label: this.elements.ceeText,
                    button: this.elements.selectCeeBtn,
                    hiddenId: 'cee'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectCeeBtn?.addEventListener('click', () => input?.click());
        this.elements.removeCeeBtn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'cee',
                hiddenId: 'cee',
                label: this.elements.ceeText,
                button: this.elements.selectCeeBtn
            });
            this.validateForm();
        });
        this.elements.tieneCEERadios.forEach(r => {
            r.addEventListener('change', () => {
                if (r.value === "si" && r.checked) DOMHelpers.show(this.elements.ceeContainer);
                if (r.value !== "si" && r.checked) {
                    DOMHelpers.hide(this.elements.ceeContainer);
                    this.removeUploadedFile({
                        key: 'cee',
                        hiddenId: 'cee',
                        label: this.elements.ceeText,
                        button: this.elements.selectCeeBtn,
                        silentIfEmpty: true
                    });
                }
                this.updatePrice();
                this.validateForm();
            });
        });
    }

    bindFile1Events() {
        const input = this.elements.file1Input;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'fichero_opcional_1',
                    label: this.elements.file1Text,
                    button: this.elements.selectFile1Btn,
                    hiddenId: 'fichero_opcional_1'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectFile1Btn?.addEventListener('click', () => input?.click());
        this.elements.removeFile1Btn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'fichero_opcional_1',
                hiddenId: 'fichero_opcional_1',
                label: this.elements.file1Text,
                button: this.elements.selectFile1Btn
            });
            this.validateForm();
        });
    }

    bindFile2Events() {
        const input = this.elements.file2Input;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'fichero_opcional_2',
                    label: this.elements.file2Text,
                    button: this.elements.selectFile2Btn,
                    hiddenId: 'fichero_opcional_2'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectFile2Btn?.addEventListener('click', () => input?.click());
        this.elements.removeFile2Btn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'fichero_opcional_2',
                hiddenId: 'fichero_opcional_2',
                label: this.elements.file2Text,
                button: this.elements.selectFile2Btn
            });
            this.validateForm();
        });
    }

    bindFile3Events() {
        const input = this.elements.file3Input;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'fichero_opcional_3',
                    label: this.elements.file3Text,
                    button: this.elements.selectFile3Btn,
                    hiddenId: 'fichero_opcional_3'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectFile3Btn?.addEventListener('click', () => input?.click());
        this.elements.removeFile3Btn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'fichero_opcional_3',
                hiddenId: 'fichero_opcional_3',
                label: this.elements.file3Text,
                button: this.elements.selectFile3Btn
            });
            this.validateForm();
        });
    }

    bindGarajeEvents() {
        const input = this.elements.notaSimpleGarajeInput;
        input?.addEventListener('change', () => {
            const file = input.files[0];
            this.processSelection({
                file,
                key: 'nota_simple_garaje',
                label: this.elements.notaSimpleGarajeText,
                button: this.elements.selectNotaSimpleGarajeBtn,
                hiddenId: 'nota_simple_garaje'
            });
            this.validateForm();
            input.value = '';
        });
        this.elements.selectNotaSimpleGarajeBtn?.addEventListener('click', () => input?.click());
        this.elements.removeNotaSimpleGarajeBtn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'nota_simple_garaje',
                hiddenId: 'nota_simple_garaje',
                label: this.elements.notaSimpleGarajeText,
                button: this.elements.selectNotaSimpleGarajeBtn
            });
            this.validateForm();
        });
        this.elements.anadirGarajeCheckbox?.addEventListener('change', () => {
            if (this.elements.anadirGarajeCheckbox.checked) {
                DOMHelpers.show(this.elements.notaSimpleGarajeContainer);
                DOMHelpers.setText(this.elements.anadirGarajeText, 'Garaje añadido por ' + this.anadirGarajePriceText);
            } else {
                DOMHelpers.hide(this.elements.notaSimpleGarajeContainer);
                DOMHelpers.setText(this.elements.anadirGarajeText, 'Añadir garaje a la tasación por ' + this.anadirGarajePriceText);
                this.removeUploadedFile({
                    key: 'nota_simple_garaje',
                    hiddenId: 'nota_simple_garaje',
                    label: this.elements.notaSimpleGarajeText,
                    button: this.elements.selectNotaSimpleGarajeBtn,
                    silentIfEmpty: true
                });
                // Remove CEE garaje
                this.removeUploadedFile({
                    key: 'cee_garaje',
                    hiddenId: 'cee_garaje',
                    label: this.elements.ceeGarajeText,
                    button: this.elements.selectCeeGarajeBtn,
                    silentIfEmpty: true
                });
            }
            this.updatePrice();
            this.validateForm();
        });
        this.elements.tieneNotaSimpleGarajeRadios.forEach(r => {
            r.addEventListener('change', () => {
                if (r.value === "si" && r.checked) DOMHelpers.show(this.elements.tieneNotaSimpleGarajeContainer);
                if (r.value !== "si" && r.checked) {
                    DOMHelpers.hide(this.elements.tieneNotaSimpleGarajeContainer);
                    this.removeUploadedFile({
                        key: 'nota_simple_garaje',
                        hiddenId: 'nota_simple_garaje',
                        label: this.elements.notaSimpleGarajeText,
                        button: this.elements.selectNotaSimpleGarajeBtn,
                        silentIfEmpty: true
                    });
                }
                this.updatePrice();
                this.validateForm();
            });
        });
    }
    bindCEEGarajeEvents() {
        const input = this.elements.ceeGarajeInput;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'cee_garaje',
                    label: this.elements.ceeGarajeText,
                    button: this.elements.selectCeeGarajeBtn,
                    hiddenId: 'cee_garaje'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectCeeGarajeBtn?.addEventListener('click', () => input?.click());
        this.elements.removeCeeGarajeBtn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'cee_garaje',
                hiddenId: 'cee_garaje',
                label: this.elements.ceeGarajeText,
                button: this.elements.selectCeeGarajeBtn
            });
            this.validateForm();
        });
        this.elements.tieneCEEGarajeRadios.forEach(r => {
            r.addEventListener('change', () => {
                if (r.value === "si" && r.checked) DOMHelpers.show(this.elements.ceeGarajeContainer);
                if (r.value !== "si" && r.checked) {
                    DOMHelpers.hide(this.elements.ceeGarajeContainer);
                    this.removeUploadedFile({
                        key: 'cee_garaje',
                        hiddenId: 'cee_garaje',
                        label: this.elements.ceeGarajeText,
                        button: this.elements.selectCeeGarajeBtn,
                        silentIfEmpty: true
                    });
                }
                this.updatePrice();
                this.validateForm();
            });
        });
    }

    bindTrasteroEvents() {
        const input = this.elements.notaSimpleTrasteroInput;
        input?.addEventListener('change', () => {
            const file = input.files[0];
            this.processSelection({
                file,
                key: 'nota_simple_trastero',
                label: this.elements.notaSimpleTrasteroText,
                button: this.elements.selectNotaSimpleTrasteroBtn,
                hiddenId: 'nota_simple_trastero'
            });
            this.validateForm();
            input.value = '';
        });
        this.elements.selectNotaSimpleTrasteroBtn?.addEventListener('click', () => input?.click());
        this.elements.removeNotaSimpleTrasteroBtn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'nota_simple_trastero',
                hiddenId: 'nota_simple_trastero',
                label: this.elements.notaSimpleTrasteroText,
                button: this.elements.selectNotaSimpleTrasteroBtn
            });
            this.validateForm();
        });
        this.elements.anadirTrasteroCheckbox?.addEventListener('change', () => {
            if (this.elements.anadirTrasteroCheckbox.checked) {
                DOMHelpers.show(this.elements.notaSimpleTrasteroContainer);
                DOMHelpers.setText(this.elements.anadirTrasteroText, 'Trastero añadido por ' + this.anadirTrasteroPriceText);
            } else {
                DOMHelpers.hide(this.elements.notaSimpleTrasteroContainer);
                DOMHelpers.setText(this.elements.anadirTrasteroText, 'Añadir trastero a la tasación por ' + this.anadirTrasteroPriceText);
                this.removeUploadedFile({
                    key: 'nota_simple_trastero',
                    hiddenId: 'nota_simple_trastero',
                    label: this.elements.notaSimpleTrasteroText,
                    button: this.elements.selectNotaSimpleTrasteroBtn,
                    silentIfEmpty: true
                });
                // Remove CEE trastero
                this.removeUploadedFile({
                    key: 'cee_trastero',
                    hiddenId: 'cee_trastero',
                    label: this.elements.ceeTrasteroText,
                    button: this.elements.selectCeeTrasteroBtn,
                    silentIfEmpty: true
                });
            }
            this.updatePrice();
            this.validateForm();
        });
        this.elements.tieneNotaSimpleTrasteroRadios.forEach(r => {
            r.addEventListener('change', () => {
                if (r.value === "si" && r.checked) DOMHelpers.show(this.elements.tieneNotaSimpleTrasteroContainer);
                if (r.value !== "si" && r.checked) {
                    DOMHelpers.hide(this.elements.tieneNotaSimpleTrasteroContainer);
                    this.removeUploadedFile({
                        key: 'nota_simple_trastero',
                        hiddenId: 'nota_simple_trastero',
                        label: this.elements.notaSimpleTrasteroText,
                        button: this.elements.selectNotaSimpleTrasteroBtn,
                        silentIfEmpty: true
                    });
                }
                this.updatePrice();
                this.validateForm();
            });
        });
    }
    bindCEETrasteroEvents() {
        const input = this.elements.ceeTrasteroInput;
        if (input) {
            input.addEventListener('change', () => {
                const file = input.files[0];
                this.processSelection({
                    file,
                    key: 'cee_trastero',
                    label: this.elements.ceeTrasteroText,
                    button: this.elements.selectCeeTrasteroBtn,
                    hiddenId: 'cee_trastero'
                });
                this.validateForm();
                input.value = '';
            });
        }
        this.elements.selectCeeTrasteroBtn?.addEventListener('click', () => input?.click());
        this.elements.removeCeeTrasteroBtn?.addEventListener('click', () => {
            this.removeUploadedFile({
                key: 'cee_trastero',
                hiddenId: 'cee_trastero',
                label: this.elements.ceeTrasteroText,
                button: this.elements.selectCeeTrasteroBtn
            });
            this.validateForm();
        });
        this.elements.tieneCEETrasteroRadios.forEach(r => {
            r.addEventListener('change', () => {
                if (r.value === "si" && r.checked) DOMHelpers.show(this.elements.ceeTrasteroContainer);
                if (r.value !== "si" && r.checked) {
                    DOMHelpers.hide(this.elements.ceeTrasteroContainer);
                    this.removeUploadedFile({
                        key: 'cee_trastero',
                        hiddenId: 'cee_trastero',
                        label: this.elements.ceeTrasteroText,
                        button: this.elements.selectCeeTrasteroBtn,
                        silentIfEmpty: true
                    });
                }
                this.updatePrice();
                this.validateForm();
            });
        });
    }

    bindShowGarajeTrasteroEvents() {
        this.elements.show_garaje_trastero?.addEventListener('click', () => {
            if (this.elements.garaje_trastero_container) {
                this.elements.garaje_trastero_container.classList.remove('tasaciones-hidden');
                this.elements.show_garaje_trastero_container.classList.add('tasaciones-hidden');
            }
        });
    }

    updatePrice() {
        this.priceCalculator.updateStep3Price(this.elements.priceElement);
    }

    validateFile(file) {
        if (!file) return { ok: false, error: 'Archivo no seleccionado.' };
        if (file.size > this.maxBytes) return { ok: false, error: 'El archivo no puede superar los ' + this.maxMBPHP + 'MB.' };
        if (!this.allowedMime.includes(file.type)) return { ok: false, error: 'Solo puede adjuntar archivos PDF.' };
        return { ok: true };
    }

    processSelection({ file, key, label, button, hiddenId }) {
        const hidden = document.getElementById(hiddenId);
        if (!file) {
            if (label) label.value = this.filePlaceholder;
            hidden.value = '';
            this.resetButton(button);
            return;
        }
        const v = this.validateFile(file);
        if (!v.ok) {
            this.clearValidationErrors(label.parentNode);
            this.showValidationErrors(label.parentNode, v.error);
            this.showError(v.error);
            hidden.value = '';
            if (label) label.value = this.filePlaceholder;
            this.resetButton(button);
            return;
        }
        if (label) label.value = file.name;
        this.uploadFile({ file, key, hiddenId, button });
    }

    uploadFile({ file, key, hiddenId, button }) {
        if (!this.ajaxUrl) {
            this.showError('Sin URL AJAX.');
            return;
        }
        this.pendingUploads++;
        this.setFormDisabled(true);

        this.setUploading(button);

        const fd = new FormData();
        fd.append('action', 'tasaciones_upload_file');
        fd.append('nonce', this.uploadNonce);
        const form = document.getElementById('tasaciones-funnel-step-3');
        const ref = form.querySelector('[name="tasaciones_funnel_ref"]').value;
        const revision = form.querySelector('[name="tasaciones_funnel_revision"]').value;
        fd.append('tasaciones_funnel_ref', ref);
        fd.append('tasaciones_funnel_step_nonce', form.querySelector('[name="tasaciones_funnel_step_nonce"]').value);
        fd.append('tasaciones_funnel_revision', revision);
        fd.append('campo', key);
        fd.append('file', file);

        fetch(this.ajaxUrl, { method: 'POST', body: fd })
            .then(r => r.json().catch(() => ({})))
            .then(json => {
                if (form.querySelector('[name="tasaciones_funnel_ref"]').value !== ref || form.querySelector('[name="tasaciones_funnel_revision"]').value !== revision || (json?.success && json.data?.context !== ref)) throw new Error('El contexto del archivo ha cambiado.');
                if (json?.success && json.data?.revision != null) form.querySelector('[name="tasaciones_funnel_revision"]').value = String(json.data.revision);
                if (!json?.success) throw new Error(json?.data?.message || json?.message || 'Error enviando el archivo.');
                const hidden = document.getElementById(hiddenId);
                if (hidden) hidden.value = json.data?.file_name || '';
                this.markUploadOk(button);
            })
            .catch(e => {
                this.showError(e.message);
                this.resetButton(button);
                const hidden = document.getElementById(hiddenId);
                if (hidden) hidden.value = '';
            })
            .finally(() => {
                this.refreshFileWrapperStatus();
                this.pendingUploads--;
                if (this.pendingUploads === 0) this.setFormDisabled(false);
            });
    }

    removeUploadedFile({ key, hiddenId, label, button, silentIfEmpty = false }) {
        const hidden = document.getElementById(hiddenId);
        const fileInput = document.getElementById(hiddenId + '_file');
        if (!hidden) {
            if (fileInput) fileInput.value = '';
            return;
        }
        const existing = hidden.value;
        if (!existing) {
            if (fileInput) fileInput.value = '';
            if (!silentIfEmpty) {
                if (label) label.value = this.filePlaceholder;
                this.resetButton(button);
            }
            return;
        }
        // Petición AJAX para borrar
        const fd = new FormData();
        fd.append('action', 'tasaciones_delete_file');
        fd.append('nonce', this.uploadNonce);
        const form = document.getElementById('tasaciones-funnel-step-3');
        const ref = form.querySelector('[name="tasaciones_funnel_ref"]').value;
        const revision = form.querySelector('[name="tasaciones_funnel_revision"]').value;
        fd.append('tasaciones_funnel_ref', ref);
        fd.append('tasaciones_funnel_step_nonce', form.querySelector('[name="tasaciones_funnel_step_nonce"]').value);
        fd.append('tasaciones_funnel_revision', revision);
        fd.append('campo', key);
        fd.append('file_path', existing);

        this.setDeleting(button);

        fetch(this.ajaxUrl, { method: 'POST', body: fd })
            .then(r => r.json().catch(() => ({})))
            .then(json => {
                if (form.querySelector('[name="tasaciones_funnel_ref"]').value !== ref || form.querySelector('[name="tasaciones_funnel_revision"]').value !== revision || (json?.success && json.data?.context !== ref)) throw new Error('El contexto del archivo ha cambiado.');
                if (json?.success && json.data?.revision != null) form.querySelector('[name="tasaciones_funnel_revision"]').value = String(json.data.revision);
                if (!json?.success) throw new Error(json?.data?.message || 'Error al borrar.');
                hidden.value = '';
                if (fileInput) fileInput.value = '';
                if (label) label.value = this.filePlaceholder;
                this.resetButton(button);
            })
            .catch(e => {
                this.showError(e.message);
                // Si falla el borrado, marcamos OK de nuevo
                this.markUploadOk(button);
            })
            .finally(() => {
                this.refreshFileWrapperStatus();
            });
    }

    setUploading(button) {
        if (!button) return;
        button.querySelector('span').innerText = 'Subiendo...';
        button.classList.remove('ok', 'error', 'deleted');
        button.classList.add('uploading');
    }

    setDeleting(button) {
        if (!button) return;
        button.querySelector('span').innerText = 'Borrando...';
        button.classList.remove('ok', 'error');
        button.classList.add('deleting');
    }

    markUploadOk(button) {
        if (!button) return;
        // button.querySelector('span')?.innerText = 'OK';
        button.classList.remove('uploading', 'error', 'deleting');
        // button.classList.add('ok');
    }

    resetButton(button) {
        if (!button) return;
        button.querySelector('span').innerText = 'Adjuntar';
        button.classList.remove('uploading', 'ok', 'error', 'deleting');
    }

    refreshFileWrapperStatus() {
        if (!this.elements.form) return;
        const wrappers = this.elements.form.querySelectorAll('.file-wrapper');
        wrappers.forEach(w => {
            const hiddenId = w.dataset.hiddenId;
            const hidden = hiddenId ? document.getElementById(hiddenId) : null;
            if (hidden?.value) {
                w.classList.add('has-file');
            } else {
                w.classList.remove('has-file');
            }
            // Valido el campo
            this.validateFormField(hidden);
        });
    }

    setFormDisabled(disabled) {
        if (!this.elements.form) return;
        const submitBtns = this.elements.form.querySelectorAll('[type="submit"]');
        submitBtns.forEach(b => b.disabled = disabled);
        this.showLoading(disabled);
    }

    validateFormField(field) {
        // Valida el formulario cada vez que un campo pierde el foco
        const formData = new FormData();
        formData.append(field.name, field.value);
        this.formValidator.validateStep3(formData);

        this.validateForm();
    }

    clearValidationErrors(field){
        const errorSpan = field.nextSibling;
        console.log(field, errorSpan);
        if (errorSpan && errorSpan.classList && errorSpan.classList.contains('error-label-message')) {
            field.parentNode.removeChild(errorSpan);
        }
    }
    showValidationErrors(field, error){
        console.log(field);
        const errorSpan = document.createElement('span');
        errorSpan.className = 'error-label-message';
        errorSpan.textContent = error;
        // Insertar después del campo
        field.parentNode.insertBefore(errorSpan, field.nextSibling);

    }

    validateForm() {
        // Validar el formulario y devolver true si es válido, false si no
        const formData = new FormData(this.elements.form);
        const errors = this.formValidator.validateStep3(formData, false);
        if (errors.length > 0) {
            this.elements.submitBtn.classList.add('disabled');
        } else {
            this.elements.submitBtn.classList.remove('disabled');
        }
        return errors.length === 0;
    }

    handleFormSubmit(event) {

        // Primero si está todavía subiendo ficheros no podemos continuar
        if (this.pendingUploads > 0) {
            event.preventDefault();
            this.showError('Esperando subidas.');
            return false;
        }

        // Segundo validar los datos antes de continuar
        try {
            const formData = new FormData(this.elements.form);

            let errors = this.formValidator.validateStep3(formData);

            if (errors.length > 0) {
                event.preventDefault();
                return false;
            }

            // Al terminar la función sin event.preventDefault(); se envía el formulario.
            this.showLoading(true);
            
        } catch (error) {
            event.preventDefault();
            console.log('Error:', error);
            this.showError('Error al guardar los datos');
            return false;
        }
        
    }

}

// Hacer la clase disponible globalmente
window.TasacionesFunnelStep3 = TasacionesFunnelStep3;